import React from 'react';
import {observer} from 'mobx-react-lite';
import ControlGroup from '../../../../components/layouts/control-group/control-group';
import {FormField} from '../../../../components/form-field/form-field';
import {Input} from '../../../../components/inputs/input/input';
import {IValidationGroup} from '../../../../hooks/validation-group/validation-group-hook';

export interface ISbrMarginsFieldsProps {
    fixedMargin: number | null | undefined;
    relativeMargin: number | null | undefined;
    onFixedMarginChange: (value: number | null) => void;
    onRelativeMarginChange: (value: number | null) => void;
    fixedMarginLabel?: string;
    relativeMarginLabel?: string;
    required?: boolean;
    disabled?: boolean;
    validationGroup?: IValidationGroup;
}

export const SBR_PLAN_DEFAULT_FIXED_MARGIN_LABEL = 'Ship by RGO fixed margin';
export const SBR_PLAN_DEFAULT_RELATIVE_MARGIN_LABEL = 'Ship by RGO relative margin';

const SbrMarginsFields: React.FC<ISbrMarginsFieldsProps> = observer(({
    fixedMargin,
    relativeMargin,
    onFixedMarginChange,
    onRelativeMarginChange,
    fixedMarginLabel = SBR_PLAN_DEFAULT_FIXED_MARGIN_LABEL,
    relativeMarginLabel = SBR_PLAN_DEFAULT_RELATIVE_MARGIN_LABEL,
    required = true,
    disabled = false,
    validationGroup,
}) => (
    <ControlGroup>
        <FormField label={fixedMarginLabel} required>
            <Input
                temp
                min={0}
                type="number"
                value={fixedMargin}
                onChange={onFixedMarginChange}
                disabled={disabled}
                required={required}
                validationGroup={validationGroup}
            />
        </FormField>

        <FormField label={relativeMarginLabel} required>
            <Input
                temp
                min={0}
                type="number"
                value={relativeMargin}
                onChange={onRelativeMarginChange}
                disabled={disabled}
                required={required}
                validationGroup={validationGroup}
            />
        </FormField>
    </ControlGroup>
));

export default SbrMarginsFields;
